import z from "zod";
import { defineObject } from "sanity-typed-queries";
var schema = defineObject("callToAction", {
    variant: {
        title: "Variant",
        type: "string",
        options: {
            list: [
                "button/primary",
                "button/secondary",
                "button/border",
                "button/ghost",
                "button/link"
            ]
        }
    },
    label: {
        title: "Label",
        type: "string"
    },
    url: {
        title: "URL",
        type: "url",
        validation: function(Rule) {
            return Rule.uri({
                allowRelative: true,
                scheme: [
                    "http",
                    "https",
                    "mailto",
                    "tel"
                ]
            });
        }
    },
    linkType: {
        title: "Link Type",
        type: "string",
        description: "Defaults to internal",
        options: {
            list: [
                "internal",
                "external"
            ]
        }
    }
});
var validator = z.object({
    variant: z.enum([
        "button/primary",
        "button/secondary",
        "button/border",
        "button/ghost",
        "button/link"
    ]),
    url: z.string(),
    label: z.string(),
    linkType: z.enum([
        "internal",
        "external"
    ])
}).partial();
schema.callToAction;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=callToAction.js.map